import { fetchPlantShareCardFile } from '../../infrastructure/content/plantShareCardFile';
import { resolveCanonicalOrigin } from '../i18n/localeDocumentMetadata';
import { SHARE_RESULTS, shareImage } from './shareImage';

/**
 * Share the plant as a scenic card — the picture built for a feed rather than
 * for a filing cabinet (SPEC-019 D-3).
 *
 * The third caller of `shareImage.js`, beside `shareApp.js` and
 * `sharePlantSheet.js`, and thin for the same reason: the ladder — file, link,
 * clipboard — belongs to none of them.
 *
 * What is particular here is the ADDRESS, and it is SPEC-020 D-6's call applied
 * to the surface that was left out of it. `window.location.href` is what the
 * plant share has always sent, and on a Firebase mirror or a preview channel
 * that is an address which is not the product's — `resolveCanonicalOrigin`
 * already names the three hostnames — and it may carry a hash the reader never
 * chose to send. The canonical address is also the one the static social
 * document is served at and the one `<link rel="canonical">` publishes, so the
 * three stay one fact (D-8).
 */

export { SHARE_RESULTS };

export function plantShareUrl(localeCode, plantId, locationObject) {
    return `${resolveCanonicalOrigin(locationObject)}/${localeCode}/plants/${plantId}`;
}

/**
 * `shape` is a parameter rather than a second function, because the shape is the
 * ONLY thing that differs between the two picture rows the chooser now offers
 * (SPEC-019 PR-19.8). A `sharePlantPostCard` beside this one would be the same
 * five lines with one word changed, which is the repo contract's "second way of
 * doing an established thing".
 */
export async function sharePlantCard(
    { plantId, commonName, languageCode, title, text, url, shape = 'portrait' },
    { nav = typeof navigator === 'undefined' ? null : navigator, loadFile = fetchPlantShareCardFile } = {},
) {
    return shareImage(
        { title, text, url },
        () => loadFile({ plantId, commonName, languageCode, shape }),
        nav,
    );
}
